export default {
    //查询pki厂家信息
    listPKIInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/pkiLogin/listPKIInfo', params, response);
    },
    //查询pki厂家信息
    pkiLogin(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/pkiLogin/pkiLogin', params, response);
    },
    //修改pki厂家信息
    editPKIInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/pkiLogin/editPKIInfo', params, response);
    }
};
